import themeService from '@/services/themeService';

export default {
  data: vm => ({
    isMobile: vm.verifyIsMobile(),
  }),
  created() {
    window.addEventListener('resize', () => {
      this.isMobile = this.verifyIsMobile();
    });
  },
  methods: {
    verifyIsMobile() {
      return themeService.isScreenSize('xs') || themeService.isScreenSize('sm');
    },
  },
};
